import { api } from '@/config/api';

export interface FbAd {
  id: string; name: string;
  adset_id: string; campaign_id: string;
  status: string; effective_status: string;
  creative?: { id?: string };
  created_time?: string; updated_time?: string;
  insights?: { data: Array<{ impressions?: string; clicks?: string; spend?: string; ctr?: string; cpc?: string }> };
}

export interface CreateAdPayload {
  expected_account_uid?: string;
  name: string;
  adset_id: string;
  creative_id: string;
  status?: 'ACTIVE' | 'PAUSED';
}

export const facebookAdsService = {
  byAdSet: async (adSetId: string, refresh = false) =>
    (await api.get(`/slighter_crm/facebook/ads/by-ad-set/${adSetId}`, { params: { refresh: refresh ? '1' : undefined } })).data as { data: FbAd[]; fetchedAt: string; fromCache: boolean },
  create: async (payload: CreateAdPayload): Promise<{ id: string }> =>
    (await api.post('/slighter_crm/facebook/ads', payload)).data,
  pause: async (adId: string, adSetId?: string) =>
    (await api.post(`/slighter_crm/facebook/ads/${adId}/pause`, undefined, { params: { adSetId } })).data,
  resume: async (adId: string, adSetId?: string) =>
    (await api.post(`/slighter_crm/facebook/ads/${adId}/resume`, undefined, { params: { adSetId } })).data,
  archive: async (adId: string, adSetId?: string) =>
    (await api.post(`/slighter_crm/facebook/ads/${adId}/archive`, undefined, { params: { adSetId } })).data,
};
